export const LENGTH_OF_PERIOD_OPTIONS = [
  { value: 1, label: 'Daily' },
  { value: 7, label: 'One week' },
  { value: 14, label: 'Two weeks' },
  { value: 21, label: 'Four weeks' },
];

export const PAYROLL_KINDS = {
  dailyPayroll: 'dailyPayroll',
  commissionSplits: 'commissionSplits',
};

export const PAYROLL_KIND_OPTIONS = [
  { value: PAYROLL_KINDS.commissionSplits, label: 'Auto Tip and Commission Splits' },
  { value: PAYROLL_KINDS.dailyPayroll, label: 'Auto Tip Only' },
];

const DISCOUNT_PAYOUT = {
  shop: 'shop',
  split: 'split',
};

export const DISCOUNT_PAYOUT_OPTIONS = [
  { value: DISCOUNT_PAYOUT.split, label: 'Split Shop/Barber' },
  { value: DISCOUNT_PAYOUT.shop, label: 'All Shop' },
];
